export const numberFormats = {
    'de-DE': {
      euro: {
        style: 'currency', currency: 'EUR', notation: 'standard'
      },
      EUR: {
        style: 'currency', currency: 'EUR', notation: 'standard'
      },
      CHF: {
        style: 'currency', currency: 'CHF', notation: 'standard'
      },
      decimal: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      percent: {
        style: 'percent', useGrouping: false
      }
    }
}